import React from "react";
import InitialMessageDescription from "./InitialMessageDescription";
import InitialMessageBullets from "./InitialMessageBullets";
import InitialMessageExample from "./InitialMessageExample";

const InitialMessage = ({
  inContent,
  toolName,
  locked,
  upgradeable,
  quotaRemaining,
  resourceTitle,
  signupPath
}) => {
  return (
    <>
      <div className="ask-litcharts-ai--intro">
        <div className="hand-wave" />
        <div className="body-2 ask-litcharts-ai--hello">
          Hello! I&apos;m LitCharts AI
        </div>
        <InitialMessageDescription
          toolName={toolName}
          resourceTitle={resourceTitle}
          inContent={inContent}
          signupPath={signupPath}
        />
      </div>
      <InitialMessageBullets
        quotaRemaining={quotaRemaining}
        inContent={inContent}
        toolName={toolName}
        signupPath={signupPath}
        locked={locked}
        upgradeable={upgradeable}
      />
      <InitialMessageExample
        toolName={toolName}
        locked={locked}
        inContent={inContent}
      />
    </>
  );
};

export default InitialMessage;
